import { Component, OnInit, Input } from '@angular/core';
import { GlobalService } from '../../../global.service';
@Component({
  selector: 'app-current-plan',
  templateUrl: './current-plan.component.html',
  styleUrls: ['./current-plan.component.sass']
})
export class CurrentplandatapurchaseComponent implements OnInit {
  @Input() index;
  public currentList;
  public info;
  public usage2: any;
  public mixed = false;
  public billingCycle: any;
  public expiration: any;
  public daysForEndOfCycle;
  constructor(private global: GlobalService) { }

  ngOnInit() {
    this.info = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).SubscriberInfo;
    this.billingCycle = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).AccounInfo.cycleDateField;
    this.expiration = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).AccounInfo.billDueDateField;

    this.daysForEndOfCycle=this.calculateDaysForEndOfCycle(JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).AccounInfo.cycleDaysLeftField);
  }
  refreshDataTo() {
    let index = parseInt(event.target["selectedIndex"]);
    let ban = this.currentList[index].account;
    sessionStorage.setItem("selectBan", btoa(ban));
    this.initializeData();
  }
  check(value) {
    if (value == 'G') {
      this.mixed = true;
    }
  }
  initializeData() {

  }
  ngAfterViewInit(): void {
    // this.loadCanvas();
    let objHtml = 'idCanvasPaq';
    this.global.pid2D(document.getElementById(objHtml), this.daysForEndOfCycle);
  }
  calculateDaysForEndOfCycle(cycleDays) {
    //calculo de los dias restante para el fin del ciclo de facturacion
    var hoy = new Date();
    var mes = hoy.getMonth() + 1;
    var diasMes;
    switch (mes) {
       case 1:diasMes = 31;break;
       case 2:diasMes = 28;break;
       case 3:diasMes = 31;break;
       case 4:diasMes = 30;break;
       case 5:diasMes = 31;break;
       case 6:diasMes = 30;break;
       case 7:diasMes = 30;break;
       case 8:diasMes = 31;break;
       case 9:diasMes = 30;break;
       case 10:diasMes = 31;break;
       case 11:diasMes = 30;break;
       case 12:diasMes = 31;break;
    }
   if (parseInt(cycleDays) < 0) {
       var porcConsumido = 0;
   } else {
       var porcConsumido = Math.round((100 * parseInt(cycleDays)) / diasMes);
   }
   return porcConsumido;
  }
  dataLoading(sw) {

    setTimeout(() => {
      this.global.loadCanvas();
    }, 2000);
  }
}

